import {
  AlignCenter as FormatAlignCenter,
  AlignJustify as FormatAlignJustify,
  AlignLeft as FormatAlignLeft,
  AlignRight as FormatAlignRight,
  AppWindow as WebAsset,
  ArrowLeft as Prev,
  ArrowRight as Next,
  ArrowRightLeft as Transform,
  AudioLines as Audio,
  Ban as Fail,
  BarChart as Chart,
  BarChart3 as Analyze,
  Bold,
  Brain,
  Bug as Debug,
  Code,
  Calendar,
  CalendarDays as CalendarEvent,
  Camera as CameraFront,
  Camera as CameraRear,
  Check,
  ChevronDown as ArrowDropDown,
  ChevronDown as ExpandMore,
  ChevronLeft as Left,
  ChevronRight as ArrowRight,
  ChevronRight as Right,
  ChevronUp as ExpandLess,
  Circle as Record,
  Circle as RecordOff,
  ClipboardList as PollResults,
  Cloud as Online,
  CloudOff as Offline,
  Columns3 as Columns,
  Copy,
  Disc as SwitchOff,
  Disc as SwitchOn,
  DoorOpen as MeetingRoom,
  Download,
  Drum,
  EllipsisVertical as MoreVertIcon,
  ExternalLink as Launch,
  ExternalLink as OpenLink,
  Eye as Preview,
  Eye as View,
  FileSearch as RestorePage,
  FileText as Page,
  Focus as Context,
  Folder,
  FolderOpen,
  Gamepad2 as Game,
  GitBranch as AccountTree,
  Globe as Embed,
  Grid3x3 as Fretboard,
  GripHorizontal as DragHandle,
  GripVertical as DragIndicator,
  Guitar as AcousticGuitar,
  Guitar as ElectricGuitar,
  Hammer as Gear,
  Headphones as Headset,
  Heart as Favorite,
  Heart as FavoriteBorder,
  HelpCircle as Help,
  HelpCircle as Question,
  History as Recent,
  Home,
  Image,
  Info,
  Italic,
  LayoutDashboard as Daw,
  LayoutGrid as GridView,
  Lightbulb as Suggestion,
  Link,
  List as Activities,
  ListMusic as PlayList,
  ListOrdered as Schema,
  LogOut as Exit,
  Maximize as FullScreen,
  Maximize as Resize,
  Menu,
  MessageCircle as Chat,
  Mic as Microphone,
  Mic as RecordVoiceOver,
  MicOff,
  Minimize as FullScreenExit,
  Minus as Remove,
  MonitorOff as PresentOff,
  MoveUp as Move,
  Music as Pool,
  Music as MusicNote,
  Network as Collaboration,
  PanelLeftClose as MenuOpen,
  PanelRight as ViewSidebar,
  Pause,
  Pencil as Edit,
  PenLine as Rename,
  PenTool as Drawing,
  Play,
  Plus as Add,
  Plus as Transpose,
  Power as Eject,
  Presentation as Performance,
  Presentation as Present,
  Printer as Print,
  Repeat as Loop,
  RefreshCw as Refresh,
  RotateCcw as RotateLeft,
  RotateCw as RotateRight,
  Rows3 as TableRows,
  Scaling as AspectRatio,
  Save,
  Search,
  Settings,
  Sparkles as SmartButton,
  Settings as Preset,
  Share2 as Share,
  Sigma as Functions,
  SlidersHorizontal as Controls,
  Smile as Emoji,
  Square as Block,
  Square as Stop,
  Star,
  Star as StarOutlined,
  Pin,
  PinOff,
  StickyNote as Note,
  Strikethrough,
  Table,
  Tag,
  Timer as Metronome,
  Trash2 as Delete,
  Type as Form,
  User as Person,
  Heading1 as Heading,
  Underline as Underlined,
  Undo2 as RestoreFromTrash,
  Upload,
  UserCheck as PollFinalOption,
  Users as Band,
  Video as Room,
  Video as VideoCam,
  VideoOff as VideoCamOff,
  Volume1 as VolumeDown,
  Volume2 as VolumeUp,
  VolumeX as VolumeMute,
  Wrench as Labs,
  Wrench as Tool,
  X as Close,
  XCircle as Cancel,
  AlertCircle as ErrorOutline,
  Ban as AccessDenied,
  ChartColumnIncreasing as ChartData,
  CheckSquare as Todo,
  Images as Gallery,
  Library as LibraryMusic,
  Library as MuscialScore,
  Mic2 as Compose,
  Mic2 as Transcribe,
  SplitSquareHorizontal as Divider,
  BarChart3 as Poll,
} from 'lucide-react'
import type { LucideProps } from 'lucide-react'
import type { FC } from 'react'
import Bass from './bass.js'
import DeadFish from './dead-fish.js'
import Evernote from './evernote.js'
import GuitarTab from './guitar-tab.js'
import Instagram from './instagram.js'
import Midi from './midi.js'
import Pdf from './pdf.js'
import Effect from './pedal.js'
import Piano from './piano.js'
import Spotify from './spotify.js'
import YouTube from './youtube.js'

const Video = Room
const Pedal = Effect
const PedalIcon = Effect
const Chord = AcousticGuitar
const Guitar = ElectricGuitar
const ViewList = Activities
const Section = MuscialScore
const Mixer = Audio
const Comment = Chat
const Convert = Transform

export const icons = {
  AccessDenied,
  AccountTree,
  AspectRatio,
  AcousticGuitar,
  Activities,
  Add,
  Analyze,
  ArrowDropDown,
  ArrowRight,
  Audio,
  Band,
  Bass,
  Block,
  Bold,
  Brain,
  Calendar,
  CalendarEvent,
  CameraFront,
  CameraRear,
  Cancel,
  Chart,
  ChartData,
  Chat,
  Check,
  Chord,
  Code,
  Close,
  Collaboration,
  Columns,
  Comment,
  Compose,
  Context,
  Controls,
  Convert,
  Copy,
  Daw,
  DeadFish,
  Debug,
  Delete,
  Divider,
  Download,
  DragHandle,
  DragIndicator,
  Drawing,
  Drum,
  Edit,
  Effect,
  Eject,
  ElectricGuitar,
  Embed,
  Emoji,
  ErrorOutline,
  Evernote,
  Exit,
  ExpandLess,
  ExpandMore,
  Fail,
  Favorite,
  FavoriteBorder,
  Folder,
  FolderOpen,
  Form,
  FormatAlignCenter,
  FormatAlignJustify,
  FormatAlignLeft,
  FormatAlignRight,
  Fretboard,
  FullScreen,
  FullScreenExit,
  Functions,
  Gallery,
  Game,
  Gear,
  GridView,
  Guitar,
  GuitarTab,
  Heading,
  Headset,
  Help,
  Home,
  Image,
  Info,
  Instagram,
  Italic,
  Labs,
  Launch,
  Left,
  LibraryMusic,
  Link,
  Loop,
  MeetingRoom,
  Menu,
  MenuOpen,
  Metronome,
  MicOff,
  Microphone,
  Midi,
  Mixer,
  MoreVertIcon,
  Move,
  MuscialScore,
  MusicNote,
  Next,
  Note,
  Offline,
  Online,
  OpenLink,
  Page,
  Pause,
  Pdf,
  Pedal,
  PedalIcon,
  Performance,
  Person,
  Piano,
  Pin,
  PinOff,
  Play,
  PlayList,
  Poll,
  PollFinalOption,
  PollResults,
  Pool,
  Present,
  PresentOff,
  Preset,
  Prev,
  Preview,
  Print,
  Question,
  Recent,
  Record,
  RecordOff,
  RecordVoiceOver,
  Refresh,
  Remove,
  Rename,
  Resize,
  RestoreFromTrash,
  RestorePage,
  Right,
  Room,
  RotateLeft,
  RotateRight,
  Save,
  Schema,
  Search,
  Section,
  Settings,
  Share,
  SmartButton,
  Song: MusicNote,
  Spotify,
  Star,
  StarOutlined,
  Stop,
  Strikethrough,
  Suggestion,
  SwitchOff,
  SwitchOn,
  Table,
  TableRows,
  Tag,
  Todo,
  Transcribe,
  Transform,
  Transpose,
  Tuner: Controls,
  Underlined,
  Upload,
  Video,
  VideoCam,
  VideoCamOff,
  View,
  ViewList,
  ViewSidebar,
  VolumeDown,
  VolumeMute,
  VolumeUp,
  WebAsset,
  YouTube,
}

// Song alias was previously a separate import
const Song = MusicNote
const Tuner = Controls

export {
  AccessDenied,
  AccountTree,
  AspectRatio,
  AcousticGuitar,
  Activities,
  Add,
  Analyze,
  ArrowDropDown,
  ArrowRight,
  Audio,
  Band,
  Bass,
  Block,
  Bold,
  Brain,
  Calendar,
  CalendarEvent,
  CameraFront,
  CameraRear,
  Cancel,
  Chart,
  ChartData,
  Chat,
  Check,
  Chord,
  Code,
  Close,
  Collaboration,
  Columns,
  Comment,
  Compose,
  Context,
  Controls,
  Convert,
  Copy,
  Daw,
  DeadFish,
  Debug,
  Delete,
  Divider,
  Download,
  DragHandle,
  DragIndicator,
  Drawing,
  Drum,
  Edit,
  Effect,
  Eject,
  ElectricGuitar,
  Embed,
  Emoji,
  ErrorOutline,
  Evernote,
  Exit,
  ExpandLess,
  ExpandMore,
  Fail,
  Favorite,
  FavoriteBorder,
  Folder,
  FolderOpen,
  Form,
  FormatAlignCenter,
  FormatAlignJustify,
  FormatAlignLeft,
  FormatAlignRight,
  Fretboard,
  FullScreen,
  FullScreenExit,
  Functions,
  Gallery,
  Game,
  Gear,
  GridView,
  Guitar,
  GuitarTab,
  Heading,
  Headset,
  Help,
  Home,
  Image,
  Info,
  Instagram,
  Italic,
  Labs,
  Launch,
  Left,
  LibraryMusic,
  Link,
  Loop,
  MeetingRoom,
  Menu,
  MenuOpen,
  Metronome,
  MicOff,
  Microphone,
  Midi,
  Mixer,
  MoreVertIcon,
  Move,
  MuscialScore,
  MusicNote,
  Next,
  Note,
  Offline,
  Online,
  OpenLink,
  Page,
  Pause,
  Pdf,
  Pedal,
  PedalIcon,
  Performance,
  Person,
  Piano,
  Pin,
  PinOff,
  Play,
  PlayList,
  Poll,
  PollFinalOption,
  PollResults,
  Pool,
  Present,
  PresentOff,
  Preset,
  Prev,
  Preview,
  Print,
  Question,
  Recent,
  Record,
  RecordOff,
  RecordVoiceOver,
  Refresh,
  Remove,
  Rename,
  Resize,
  RestoreFromTrash,
  RestorePage,
  Right,
  Room,
  RotateLeft,
  RotateRight,
  Save,
  Schema,
  Search,
  Section,
  Settings,
  Share,
  SmartButton,
  Song,
  Spotify,
  Star,
  StarOutlined,
  Stop,
  Strikethrough,
  Suggestion,
  SwitchOff,
  SwitchOn,
  Table,
  TableRows,
  Tag,
  Todo,
  Tool,
  Transcribe,
  Transform,
  Transpose,
  Tuner,
  Underlined,
  Upload,
  Video,
  VideoCam,
  VideoCamOff,
  View,
  ViewList,
  ViewSidebar,
  VolumeDown,
  VolumeMute,
  VolumeUp,
  WebAsset,
  YouTube,
}

export type IconName = keyof typeof icons
export const iconNames = Object.keys(icons) as IconName[]

export interface IconProps extends LucideProps {
  className?: string
}

type SvgIconComponent = FC<IconProps>
export type { SvgIconComponent }
